export default __webpack_public_path__ + "static/media/move_to_high_info.ecaa736b.png";